import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'suffixedNumber', pure: true })
export class SuffixedNumberPipe implements PipeTransform {
  transform(value: number): string {
    let precision: number;
    let suffix: string;
    if (value < 99) {
      suffix = '';
      precision = 1;
    }
    /* eslint-disable no-dupe-else-if */
    if (value < 999) {
      suffix = '';
      precision = 0;
    } else if ((value /= 1000) < 99) {
      precision = 1;
      suffix = 'k';
    } else if (value < 999) {
      precision = 0;
      suffix = 'k';
    } else if ((value /= 1000) < 99) {
      precision = 1;
      suffix = 'm';
    } else {
      precision = 0;
      suffix = 'm';
    }
    /* eslint-enable no-dupe-else-if */
    return `${value.toFixed(precision)}${suffix}`;
  }
}
